import { AddRecipeContainer } from "@/components/recipes/AddRecipeContainer";
import { usePageBreadcrumbs } from "@/components/layout/breadcrumb-context";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export default function AddRecipePage() {
  const [searchParams] = useSearchParams();
  const recipeBoxId = searchParams.get("recipeBoxId") ?? undefined;

  usePageBreadcrumbs(
    useMemo(
      () => [
        { label: "Recipe Boxes", href: "/home" },
        { label: "Add Recipe" },
      ],
      [],
    ),
  );

  return (
    <div className="container max-w-6xl mx-auto py-6 px-4 space-y-8">
      {/* Header */}
      <div className="space-y-2">
        <h1 className="font-headline text-3xl font-semibold tracking-tight">Add a New Recipe</h1>
        <p className="text-muted-foreground">
          Import a recipe from a website or enter the details manually.
        </p>
      </div>
      <AddRecipeContainer defaultRecipeBoxId={recipeBoxId} />
    </div>
  );
}

